import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgSelectModule } from '@ng-select/ng-select';
import { CookieService } from 'ngx-cookie-service';
import { ApiConfiguration } from './api/api-configuration';
import { ApiModule } from './api/api.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ContactComponent } from './components/contact/contact.component';
import { AppConfigService } from './config/app-config.service';
import { CoreModule } from './core/core.module';
import { TekstResourceService } from './core/services/tekstresource/tekstresource.service';
import { DynamicFormModule } from './dynamic-form/dynamic-form.module';
import { DigitalSigneringKvitteringComponent } from './pages/digital-signering-kvittering/digital-signering-kvittering.component';
import { DigitalSigneringMitidMobileComponent } from './pages/digital-signering-mitid-mobile/digital-signering-mitid-mobile.component';
import { DigitalSigneringMitidComponent } from './pages/digital-signering-mitid/digital-signering-mitid.component';
import { DigitalsigneringMobileComponent } from './pages/digital-signering-mobile/digital-signering-mobile.component';
import { DigitalSigneringComponent } from './pages/digital-signering/digital-signering.component';
import { FrontPageComponent } from './pages/front-page/front-page.component';
import { LayoutPageComponent } from './pages/layout-page/layout-page.component';
import { LoggedOutPageComponent } from './pages/logged-out-page/logged-out-page.component';
import { SagRedirectComponent } from './pages/sag-redirect/sag-redirect.component';
import { SkiftBrugerComponent } from './pages/skift-bruger/skift-bruger.component';

const appInitializerFn = (
  appConfigService: AppConfigService,
  apiConfiguration: ApiConfiguration,
  tekstResourceService: TekstResourceService
) => {
  return (): Promise<any> => {
    return new Promise((resolve, reject) => {
      const configDeps: Promise<any>[] = [];
      appConfigService
        .loadAppConfig()
        .then(appConfig => {
          apiConfiguration.rootUrl = appConfig.publicApiUrl;
          configDeps.push(tekstResourceService.initialize());
          return Promise.all(configDeps);
        })
        .then(() => resolve());
    });
  };
};

@NgModule({
  declarations: [
    AppComponent,
    ContactComponent,
    FrontPageComponent,
    LayoutPageComponent,
    LoggedOutPageComponent,
    SkiftBrugerComponent,
    DigitalSigneringComponent,
    DigitalSigneringKvitteringComponent,
    SagRedirectComponent,
    DigitalSigneringMitidComponent,
    DigitalsigneringMobileComponent,
    DigitalSigneringMitidMobileComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    ApiModule,
    NgSelectModule,
    DynamicFormModule,
    CoreModule, // This should always be LAST imported module
  ],
  providers: [
    AppConfigService,
    CookieService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializerFn,
      multi: true,
      deps: [AppConfigService, ApiConfiguration, TekstResourceService],
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
